export const enum Platform {
  WINDOWS = 'windows',
  IOS = 'ios',
  ANDROID = 'android'
}
